var map = {
	"./Other.webp": "./assets/images/downloads/Other.webp",
	"./PDF.webp": "./assets/images/downloads/PDF.webp",
	"./Software.webp": "./assets/images/downloads/Software.webp",
	"./Video.webp": "./assets/images/downloads/Video.webp",
	"./Word.webp": "./assets/images/downloads/Word.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/downloads sync recursive ^\\.\\/.*$";